import { styled } from '@mui/material/styles';
import { getDrugTestThemeTokens } from '../themeTokens';

export const AuditSectionRoot = styled('div')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    border: `1px solid ${t.borderSoft}`,
    borderRadius: 8,
    overflow: 'hidden',
    background: t.surfaceMuted,
    marginBottom: 16,
  };
});

export const CollapsiblePanel = styled('details')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    border: 'none',
    borderRadius: 0,
    borderBottom: `1px solid ${t.borderSoft}`,
    background: t.surfaceMuted,
    '&:last-child': {
      borderBottom: 'none',
    },
    '& summary::-webkit-details-marker': {
      display: 'none',
    },
    '& summary::after': {
      content: '"▸"',
      fontSize: 11,
      transition: 'transform 0.15s ease',
    },
    '&[open] summary::after': {
      transform: 'rotate(90deg)',
    },
  };
});

export const PanelSummary = styled('summary')(({ theme }) => ({
  cursor: 'pointer',
  padding: '12px 16px',
  fontSize: 12,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: getDrugTestThemeTokens(theme).textMuted,
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
}));

export const PanelCount = styled('span')({
  fontWeight: 500,
  textTransform: 'none',
  letterSpacing: 'normal',
  fontSize: 12,
});

export const TableWrap = styled('div')(({ theme }) => ({
  overflowX: 'auto',
  margin: 0,
  borderTop: `1px solid ${getDrugTestThemeTokens(theme).borderSoft}`,
}));

export const Table = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 13,
  background: getDrugTestThemeTokens(theme).surface,
}));

export const Th = styled('th')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    background: t.tableHeader,
    textAlign: 'left',
    padding: '12px 14px',
    fontWeight: 600,
    color: t.textMuted,
    fontSize: 12,
    whiteSpace: 'nowrap',
    borderBottom: `1px solid ${t.border}`,
  };
});

export const Td = styled('td')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    padding: '12px 14px',
    borderBottom: `1px solid ${t.borderSoft}`,
    verticalAlign: 'top',
    color: t.text,
  };
});

export const MonoCell = styled(Td)({
  fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
  fontSize: 12,
});

export const EmptyCell = styled('td')(({ theme }) => ({
  textAlign: 'center',
  color: getDrugTestThemeTokens(theme).textMuted,
  fontSize: 13,
  padding: '24px 12px',
}));
